import React from 'react'
import { Box, Chip } from '@mui/material'
import { LocationTypesEnum } from '../../../pages/adgroup/settings/geoTargeting/GeoTargetingFields'
import { getGeoLocationChipLabel } from './geoLocationChipLabel'
import { GeoLocationChipOption } from './renderGeoLocationChips'

type GeoLocationChipListProps = {
  locations: GeoLocationChipOption[]
  locationType: LocationTypesEnum
  fieldName: string
  readOnly?: boolean
  onCityRadiusClick?: (cityFieldName: string) => void
  onRemove?: (index: number) => void
}

const GeoLocationChipList: React.FC<GeoLocationChipListProps> = ({
  locations,
  locationType,
  fieldName,
  readOnly = false,
  onCityRadiusClick,
  onRemove,
}) => {
  if (locations.length === 0) return null

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
      {locations.map((option, index) => {
        const cityFieldName = `${fieldName}.[${index}]`

        return (
          <Chip
            key={`${getGeoLocationChipLabel(option, locationType)}-${index}`}
            label={getGeoLocationChipLabel(option, locationType)}
            onDelete={readOnly || !onRemove ? undefined : () => onRemove(index)}
            onClick={
              onCityRadiusClick && locationType === LocationTypesEnum.Cities
                ? () => onCityRadiusClick(cityFieldName)
                : undefined
            }
          />
        )
      })}
    </Box>
  )
}

export default GeoLocationChipList
